export const pestControlQueryKeys = {
  all: ['pest-control'] as const,
  points: () => ['pest-control', 'points'] as const,
  calendar: (from: string, to: string) => ['pest-control', 'calendar', from, to] as const,
  records: (from: string, to: string) => ['pest-control', 'records', from, to] as const,
  pointHistory: (pointId: string, from: string | null, to: string | null) =>
    ['pest-control', 'point-history', pointId, from, to] as const,
};
